import React from 'react';
import { segmentTrack } from 'flow/actions/segment-actions';
import IconButton from 'flow/components/ui-components/IconButton';
import Icon from 'flow/components/ui-components/Icon';
import { useModal } from 'flow/contexts/ModalProvider';
import { useAppDispatch } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { PremadeAnswer } from 'flow/types/Chats';
import { TicketKey } from 'flow/types/EntityKeys';

interface Props {
    ticketKey: TicketKey;
    disabled?: boolean;
    onSelectAnswer: (answer: PremadeAnswer) => void;
}

const PremadeAnswerButton = ({
    ticketKey,
    disabled,
    onSelectAnswer,
}: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();
    const dispatch = useAppDispatch();

    return (
        <IconButton
            tooltipLabel={i18next.t('premadeAnswer.emailSignature')}
            disabled={disabled}
            onClick={() => {
                openModal('premadeAnswerTicket', {
                    ticketKey,
                    onSelectAnswer,
                });
                dispatch(
                    segmentTrack('premade_answer_ticket_icon', {
                        component: 'Ticket footer',
                    }),
                );
            }}
        >
            <Icon iconKey="article" />
        </IconButton>
    );
};

export default React.memo(PremadeAnswerButton);
